export const UPLOAD_QUEUE_BASE = 'upload_queue/UPLOAD_QUEUE_BASE';
export const ADD_TO_QUEUE = 'upload_queue/ADD_TO_QUEUE';
export const CANCEL_POLLING = 'upload_queue/CANCEL_POLLING';
export const POLLING_TIMEOUT = 'upload_queue/POLLING_TIMEOUT';
export const POLLING_COMPLETE = 'upload_queue/POLLING_COMPLETE';
